var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-event"},[(_vm.loading)?_c('loading-wheel'):_c('div',{staticClass:"flexcontainer"},_vm._l((JSON.parse(_vm.event.slots)),function(slot,key){return _c('LowerThirdElement',{key:key,attrs:{"eventslotid":key,"eventslot":slot}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }